import script from "./SeoPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SeoPage.vue?vue&type=script&setup=true&lang=js"

import "./SeoPage.vue?vue&type=style&index=0&id=3addaffb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3addaffb"]])

export default __exports__